import React from 'react';
import PropTypes from 'prop-types';
import { logo } from 'assets/img';
import { Typography, Icon, Button } from 'components/alf-design';
import { Row, Col } from 'components/alf-design/Grid';
import { useResponsive } from 'utils';

const AppBarPayment = ({
  onLogin,
  onCreateAccount,
  onSideBar,
  onLogo,
  breakpoint = 'lg',
}) => {
  const { screenIsUp, screenIsDown } = useResponsive();
  return (
    <>
      <header className="w-full bg-legacy-white" role="banner">
        <nav className="flex w-full items-center justify-between pt-[20px] pb-[10px] pl-[10px] md:py-[10px] md:pr-[30px] md:pl-[100px]">
          <div className="flex items-center">
            {screenIsDown(breakpoint) && (
              <Button
                ariaLabel="Menu"
                type="icon"
                style={{ margin: '0px 26px' }}
                id="Menu-Icon"
                onClick={onSideBar}
                icon={
                  <Icon
                    name="menu"
                    fontSize={24}
                    color="#6647DC"
                    style={{ margin: '4px' }}
                  />
                }
              />
            )}
            <Button
              id="slide-logo"
              data-testid="slide-logo"
              ariaLabel="Slide Insurance dashboard"
              type="icon"
              onClick={onLogo}
              className="bg-transparent border-0 p-0"
              icon={
                <img
                  src={logo}
                  alt="Slide Insurance dashboard"
                  className="w-[80px] cursor-pointer select-none"
                />
              }
            />
          </div>
          {screenIsUp(breakpoint) && (
            <Row className="[&>div]:ml-3 [&>div]:inline-block [&>div]:align-middle">
              <Col className="!ml-0 cursor-pointer select-none px-[16px]">
                <Typography
                  id="create-account"
                  type="linkButton"
                  component="button"
                  onClick={onCreateAccount}
                  withTab
                  className="!text-[16px]"
                >
                  Create Account
                </Typography>
              </Col>
              <Col className="cursor-pointer select-none">
                <Button
                  id="app-bar-login"
                  ariaLabel="login button"
                  type="brand"
                  component="button"
                  onClick={onLogin}
                  withTab
                  className="w-[100px]"
                >
                  Log In
                </Button>
              </Col>
            </Row>
          )}
        </nav>
        <Row className="flex h-[80px] items-center bg-legacy-secondary pl-[50px] md:h-[140px] md:pl-[100px] xl:h-[200px]">
          <Typography className="font-inter font-semibold !text-legacy-white text-[20px] md:text-[30px]">
            Make a One-Time Payment
          </Typography>
        </Row>
      </header>
    </>
  );
};

AppBarPayment.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onCreateAccount: PropTypes.func.isRequired,
  onSideBar: PropTypes.func.isRequired,
  onLogo: PropTypes.func,
};

export default AppBarPayment;
